import React from 'react';

interface NewShevronDownIconProps {
	size?: number;
	color?: string;
	style?: React.CSSProperties;
}

const NewShevronDownIcon: React.FC<NewShevronDownIconProps> = ({size = 10, color = '#262738', style = {}}) => {
	return (
		<svg width={size} height={size * 0.7} viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
			<path d="M9 1L5 5L1 0.999999" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
		</svg>
	);
}

export default NewShevronDownIcon;
